import { LoaderWithoutSuir } from './LoaderWithoutSuir';
import { LoaderProps } from './types';

export const Loader = (props: LoaderProps) => <LoaderWithoutSuir {...props} />;
